import { Injectable } from '@angular/core';
import { Project } from '../objects/project';
import { ProjectService } from './project.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class ProjectHistoryService {
  private readonly HISTORY_LIMIT = 11;
  private step = 0;
  private history: Project[] = [];
  constructor(private projectService: ProjectService) {}

  public getProjectForRedo() {
    if (this.step - 1 >= 0) {
      this.step--;
      return this.history[this.step];
    } else {
      throw new Error('No projects to redo');
    }
  }

  public getProjectForUndo() {
    if (this.step + 1 < this.history.length) {
      this.step++;
      return this.history[this.step];
    } else {
      throw new Error('No projects to undo');
    }
  }

  public clearHistory() {
    this.history = [];
  }

  public updateHistory(): void {
    if (this.history.length >= this.HISTORY_LIMIT) {
      this.history.pop();
    }
    if (this.step !== 0) {
      this.history.splice(0, this.step);
      this.step = 0;
    }
    const project: Project = _.cloneDeep(this.projectService.getState());
    const isMm: boolean = project.options.unit === 'mm';
    if (isMm) {
      project.options.unit = 'cm';
    }
    this.history.splice(0, 0, project);
  }

  public isRedoImpossible(): boolean {
    return this.step === 0;
  }

  public isUndoImpossible(): boolean {
    return this.step + 1 >= this.history.length;
  }
}
